import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, withStyles, Zoom } from '@material-ui/core';

const StyledTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#ffffff !important',
    color: `${theme.palette.primary.dark} !important`,
    boxShadow: theme.customShadows?.z8 || theme.shadows[8],
    fontWeight: 'bold',
    fontSize: '12.5px',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '8px',
    position: 'relative',
    padding: '8px 12px',
    overflow: 'visible',
    // Hardware acceleration for smoother frame rates
    willChange: 'transform, opacity',
  },
  arrow: {
    color: '#ffffff', 
    width: '14px',
    height: '7px',
    '&[data-popper-placement*="top"]': {
      bottom: '0px !important', 
    },
    '&::before': {
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: '#ffffff',
      boxSizing: 'border-box',
      zIndex: 0,
    }
  }
}))(Tooltip);

export default function CustomTooltip({ title, children, ...other }) {
  return (
    <StyledTooltip 
      title={title} 
      arrow 
      placement="top" 
      interactive 
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: 300 }}
      {...other}
    >
      {children}
    </StyledTooltip>
  );
}

CustomTooltip.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.element.isRequired
};